import { http } from "../http-common";

const getAllRoles = () => {
  return http.get("/profiles?attribute=Local");
};

const getPromptActionUsers = (keyword, profileNames, cropYear) => {
  return http.get(`/prompt-action-user/find`, {
    params: {
      keyword,
      profileNames,
      cropYear,
    },
  });
};

const updatePromptActionUsers = (data, cropYear) => {
  return http.put(`/prompt-action-user/update-checked`, data, {
    params: {
      cropYear,
    },
  });
};

const PromptActionService = {
  getAllRoles,
  getPromptActionUsers,
  updatePromptActionUsers,
};

export default PromptActionService;
